module.exports = __webpack_public_path__ + "img/prop-tv-3-right.84c48e70.png";